import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loader$ = new BehaviorSubject(false);
  constructor() {}

  showLoader() {
    this.loader$.next(true);
  }
  hideLoader() {
    this.loader$.next(false);
  }

  getLoaderState() {
    return this.loader$.asObservable();
  }
}
